export const VALIDATE_RULE = {
    channelName: {
        label: '渠道包名称',
        regx: /^[\S]{1,128}$/,
    },
    url: {
        label: '下载链接',
        regx: /^https?:\/\/.{0,300}$/, // 前端放开url校验，校验工作放后端
        // regx: /^https?:\/\/([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,4})(\/[a-zA-Z0-9`~!@#%&_=;$^*()\-+{}[\]:,.?/]{0,300})?$/,
    },
    files: {
        label: '渠道包',
    },
    urlFile: {
        label: '渠道包下载链接',
    },
}
export const MAX_PKG_SIZE = 3072 * 1024 * 1024
export const MAX_URL_CSV_SIZE = 2 * 1024 * 1024
export const MAX_UPLOAD_FILE_COUNT = 100
export const supprotPKGFileExts = ['apk']
export const supportURLFileExts = ['xlsx', 'xls']
